import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { cn } from "@tellescope/ui";

export interface InboxTemplateSelectorRowProps {
  template: TellescopeModelFromName<"templates">;
  isPreviewed: boolean;
  onPreview: (templateId: string) => void;
  onSelect: (template: TellescopeModelFromName<"templates">) => void;
}

export const InboxTemplateSelectorRow = ({
  template,
  isPreviewed,
  onPreview,
  onSelect,
}: InboxTemplateSelectorRowProps) => (
  <button
    className={cn(
      "w-full mb-2 px-3 py-2 border rounded-md text-left space-y-1 hover:bg-gray-50",
      isPreviewed && "border-primary bg-gray-50"
    )}
    onClick={() => onPreview(template.id)}
    onDoubleClick={() => onSelect(template)}
    data-testid={`template-option-${template.id}`}
  >
    <p className="text-sm font-semibold line-clamp-1">{template.title}</p>
    {!!template.subject && <p className="text-xs text-muted-foreground line-clamp-2">{template.subject}</p>}
  </button>
);
